import React from 'react';
import Svgs from '../../resources/svgs';
import './scroller.scss';

const Scroller = (props) =>
        <>
            {props.currentVisible !== 1
            ? <div
              className="scroll-arrow scroll-left"
              onClick={() => {
                props.handleStep(props.currentVisible - 1);
              }}
            >
              {Svgs.leftChevron}
            </div>
           : null}
           <div className = "scroll-pips-container">{
           [...new Array(props.maxIndex)].map(
               (item, index) =>
               <span
               key = {index}
                className = {
                    `scroll-index-pip${index + 1  === props.currentVisible ? ' active-index' : ''}`
                }
                onClick={() => {
                    props.handleStep(index + 1);
                }}
                ></span>
                )

           }</div>
          {props.currentVisible !== props.maxIndex
            ? <div
              className="scroll-arrow scroll-right"
              onClick={() => {
                props.handleStep(props.currentVisible + 1);
              }}
            >
              {Svgs.rightChevron}
            </div> : null
    }
        </>;


export default Scroller;
